import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AbsenceList from "../components/AbsenceList";
import PageHeader from "../../../../components/Common/PageHeader";
import '../styles/skeleton.css';
import { all_routes } from "router/all_routes";

const AbsencePage: React.FC = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <PageHeader
          title={t("absences_list")}
          breadcrumbItems={[
            { label: "dashboard", path: all_routes.dashboard },
            { label: "absences", active: true }
          ]}
        />

        {/* Absence List */}
            <AbsenceList role="pedagogy-director" />
      </div>
    </div>
  );
};

export default AbsencePage;
